import { render, staticRenderFns } from "./BackerCenterUpdateFeedSection.vue?vue&type=template&id=48f2e6c2"
import script from "./BackerCenterUpdateFeedSection.vue?vue&type=script&lang=js"
export * from "./BackerCenterUpdateFeedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports